export default "__VITE_ASSET__BptDt$J___"